<template>
  <header>
    <div class="overlay" v-show="navOpen"></div>
    <div class="container">
      <div class="row">

        <div class="col-xs-2">
          <router-link to="/">
            <h1 class="logo">Label Interactive</h1>
          </router-link>
        </div>

        <div id="hamburger" class="visible-xs" :class="hamburgerClass" @click="navOpen = !navOpen;">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>

        <nav class="col-sm-10" @click="closeIfOpen">
          <nav-links class="hidden-xs pull-right"></nav-links>
          <nav-links class="text-center mobile" v-show="navOpen"></nav-links>
        </nav>

      </div>
    </div>
  </header>
</template>

<script>
  import NavLinks from 'components/NavLinks';

  export default {

    components: { NavLinks },

    data() {
      return {
        navOpen: false,
        ready:   false,
      };
    },

    methods: {

      closeIfOpen() {
        if (this.navOpen) {
          this.navOpen = false;
        }
      },

    },

    computed: {

      hamburgerClass() {
        return {
          open: this.navOpen,
        };
      },

    },

  };
</script>

<style scoped>
  header {
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999999999;
    position: fixed;
    padding: 10px 0;
    background-color: #FFF;
  }

  .logo {
    margin: 0;
    text-indent: -99999px;
    height: 50px;
    width: 50px;
    background: url("~assets/images/logo.svg") no-repeat center;
  }

  nav {
    top: 50%;
    right: 0;
    position: absolute;
    transform: translateY(-50%);
  }

  .scroll-page header {
    background-color: transparent;
    transition: background-color 0.25s ease;
  }

  .scroll-page .logo {
    opacity: 0;
  }

  .scroll-page .logo {
    transition: opacity .25s ease-in-out;
  }

  .half-vh .logo {
    opacity: 1;
  }

  .half-vh header {
    background-color: #FFF;
  }

  .overlay {
    position: fixed;
    top: 0;
    height: 100%;
    width: 100%;
    background-color: #FFF;
    opacity: 0.9;
  }

  #hamburger {
    width: 39px;
    height: 26px;
    position: absolute;
    right: 25px;
    top: 20px;
    transform: rotate(0deg);
    transition: .5s ease-in-out;
    cursor: pointer;
  }

  #hamburger span {
    display: block;
    position: absolute;
    height: 5px;
    width: 100%;
    background: #638E9C;
    border-radius: 9px;
    opacity: 1;
    left: 0;
    transform: rotate(0deg);
    transition: .25s ease-in-out;
  }

  #hamburger span:nth-child(1) {
    top: 0px;
  }

  #hamburger span:nth-child(2), #hamburger span:nth-child(3) {
    top: 13px;
  }

  #hamburger span:nth-child(4) {
    top: 26px;
  }

  #hamburger.open span:nth-child(1) {
    top: 13px;
    width: 0%;
    left: 50%;
  }

  #hamburger.open span:nth-child(2) {
    transform: rotate(45deg);
  }

  #hamburger.open span:nth-child(3) {
    transform: rotate(-45deg);
  }

  #hamburger.open span:nth-child(4) {
    top: 16px;
    width: 0%;
    left: 50%;
  }

  @media (max-width: 767px) {
    nav {
      width: 100%;
      top: 150px;
    }

    .mobile {
      font-size: 32px;
    }
  }
</style>



// WEBPACK FOOTER //
// Nav.vue?5d38ad57